import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bird, Cat, Dog, Fish, PawPrint, Rabbit, Rat, Turtle } from 'lucide-react';
/**
 * lucide has no horse/hoof icon, so we draw a horseshoe in the lucide line
 * style (24x24, no fill, currentColor stroke). Used for equine and other
 * hooved livestock.
 */
function Hoof({ className, size = 24, ...props }) {
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: className, ...props, children: [_jsx("path", { d: "M7 20 A 8 8 0 1 1 17 20" }), _jsx("path", { d: "M7 20v1.5M17 20v1.5" })] }));
}
/**
 * Maps a DICOM/veterinary species string to a representative glyph for quick
 * visual triage in worklists. Hooved animals (equine + farm livestock) use the
 * horseshoe; anything unmapped or exotic falls back to a paw print.
 */
const SPECIES_ICON = {
    // Companion
    canine: Dog,
    dog: Dog,
    k9: Dog,
    feline: Cat,
    cat: Cat,
    // Hooved (equine + livestock) -> horseshoe
    equine: Hoof,
    horse: Hoof,
    pony: Hoof,
    bovine: Hoof,
    cow: Hoof,
    ovine: Hoof,
    sheep: Hoof,
    caprine: Hoof,
    goat: Hoof,
    porcine: Hoof,
    pig: Hoof,
    swine: Hoof,
    camelid: Hoof,
    alpaca: Hoof,
    llama: Hoof,
    // Small / exotic
    rabbit: Rabbit,
    lagomorph: Rabbit,
    avian: Bird,
    bird: Bird,
    fish: Fish,
    piscine: Fish,
    rodent: Rat,
    murine: Rat,
    rat: Rat,
    mouse: Rat,
    hamster: Rat,
    'guinea pig': Rat,
    ferret: Rat,
    reptile: Turtle,
    chelonian: Turtle,
    turtle: Turtle,
    tortoise: Turtle,
};
export function SpeciesIcon({ species, ...props }) {
    const key = species?.trim().toLowerCase() ?? '';
    // Exotic/other/unknown all fall through to a neutral paw print.
    const Icon = SPECIES_ICON[key] ?? PawPrint;
    return _jsx(Icon, { ...props });
}
